"use client";
import React, { useState } from "react";
import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import ReactMarkdown from "react-markdown";

type FaqProps = {
  faqData: {
    question: string;
    answer: string;
  }[];
  translations:any;
};

export default function Faq({ translations, faqData }: FaqProps) {
  const [open, setOpen] = useState([true, true, ...Array(faqData.length - 2).fill(false)]);

  const handleOpen = (index: number) => {
    // Create a new array based on the current state
    const updatedOpen = open.map((item, idx) => {
      // Toggle the state only for the clicked item
      if (idx === index) {
        return !item;
      }
      return item;
    });

    setOpen(updatedOpen);
  };

  return (
    <div className="z-0 mx-auto w-full px-0 sm:max-w-xl">
      <h2 className="flex justify-center my-8 text-center text-3xl font-bold text-white">
        {translations.faq}
      </h2>
      {faqData.map((faq, index) => (
        <div key={index} className="shadow-md">
          <Accordion
            key={index}
            open={open[index]} // Set open based on the state for this index
            icon={<Icon id={index} open={open[index]} />} // Pass state for this index to Icon
            className="mb-4 border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] px-5 py-2 sm:rounded-lg md:px-4"
          >
            <AccordionHeader
              onClick={() => handleOpen(index)} // Pass current index
              className={`text-md border-b-0 px-0 py-2 text-white ${
                open[index] ? "text-white hover:!text-white" : ""
              }`}
            >
              {faq.question}
            </AccordionHeader>
            <AccordionBody className="text-md text-white">
              <ReactMarkdown>{faq.answer}</ReactMarkdown>
            </AccordionBody>
          </Accordion>
        </div>
      ))}
    </div>
  );
}

function Icon({ id, open }: { id: number; open: boolean }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}
